import {
  MINWAGE_GET_WAGES_BY_JURISDICTION,
  MINWAGE_SET_NOTIFICATIONS_ERROR,
  MINWAGE_SET_WAGES_BY_JURISDICTION
} from './actionTypes'

export const getWagesByJurisdiction = (id) => ({
  type: MINWAGE_GET_WAGES_BY_JURISDICTION,
  meta: {},
  payload: { id }
})

export const setNotificationsError = (data) => ({
  type: MINWAGE_SET_NOTIFICATIONS_ERROR,
  meta: {},
  payload: data
})

export const setWagesByJurisdiction = (data) => ({
  type: MINWAGE_SET_WAGES_BY_JURISDICTION,
  meta: {},
  payload: data
})

export default {
  getWagesByJurisdiction,
  setWagesByJurisdiction
}
